import { css } from 'linaria';

export const BannersCarouselControlWrapper = css`
  display: block;
  position: absolute;
  top: 50%;
  z-index: 10;
  width: content-box;
  height: content-box;

  @media (--only-mobile) {
    display: none !important;
  }
`;

export const BannersCarouselControlWrapperLeft = css`
  left: 0;
  translate: -50% -50%;
`;

export const BannersCarouselControlWrapperRight = css`
  right: 0;
  translate: 50% -50%;
`;
